module.exports = __webpack_public_path__ + "img/surat.190c5ac0.png";